import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DialogPopup from 'components/molecules/DialogPopup';
import tab from 'assets/images/tab.png';
import { useNavigate } from 'react-router-dom';
import TopSearch from 'components/utilized/studentDashboard/TopSearch';
import PopupResources from 'components/utilized/workspace/PopupResources';
import PopupBookmarks from 'components/utilized/workspace/PopupBookmarks';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Box, Grid } from '@mui/material';
import Agenda from 'components/utilized/dashboard/Agenda';
import { useMedia } from 'utils/customHooks/useMedia';

import agenda from 'assets/images/agenda.jpg'
import classroom from 'assets/images/classroom.jpg'
import Classroom from 'components/utilized/dashboard/Classroom';
import EarlyWarningsSlider from 'components/utilized/dashboard/EarlyWarningsSlider';
import Meetings from 'components/utilized/dashboard/Meetings';
import Assignments from 'components/utilized/dashboard/Assignments';
import GroupCourses from 'components/utilized/dashboard/GroupCourses';
import Classes from 'components/utilized/dashboard/Classes';
import Chat from 'components/utilized/dashboard/Chat';
import LearningProgression from 'components/utilized/dashboard/LearningProgression';
import BenchmarkMasterySlider from 'components/utilized/dashboard/BenchmarkMasterySlider';


const TeacherWorkspacePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
  
    const [popup, setPopup] = useState(null)
    const [popupTitle, setPopupTitle] = useState(null)
  
    const [topSearch, setTopSearch] = useState(null)
    const user = useSelector((state: RootState) => state['user'].user)

    const { isUnder1200px,isUnder900px } = useMedia()


    const centerBoxStyle = {
      height: '100%'
    }
  


    return (
        <>
              <div className="container">
  
                  <div className="workspace-top-tabs" style={{ width: 'auto' }}>
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              setPopupTitle(t('goalbank.resources'))
                              setPopup('resources')
                          }}>
                          <div className="workspace-top-tab-title">{t('goalbank.resources')}</div>
                      </div>
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              setPopupTitle(t('dashboard.bookmarks'))
                              setPopup('bookmarks')
                          }}>
                          <div className="workspace-top-tab-title">{t('dashboard.bookmarks')}</div>
                      </div>
                      
                  </div>
  
                  <div style={{ height: '40px' }} />
  
                  <TopSearch handleSearch={(qry) => {
                      setPopupTitle(t('goalbank.resources'))
                      setTopSearch(qry)
                      setPopup('resources')
                  }} />


                  {user &&
                  <div className='workspace-avatar-title' style={{marginTop: '20px', marginBottom: '30px'}}>
                        {t('common.welcome')}, {user.first_name}!
                  </div>}



                  <Grid container rowSpacing={3} columnSpacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                      <Box className='thick-border transparent-background' sx={{
                            ...centerBoxStyle, 
                            height: '350px', overflowY: 'auto', 
                            backgroundImage: `url(${agenda})`, 
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center right',
                            backgroundSize: 'cover', 
                          }}><Agenda /></Box>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <Box className='thick-border transparent-background' sx={{
                        ...centerBoxStyle,
                        height: '350px', overflowY: 'auto', 
                        backgroundImage: `url(${classroom})`, 
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover', 
                      }}><Classroom /></Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Box className='thick-border dashboard-page-section' sx={{ maxHeight: '400px', overflowY: 'auto' }}><GroupCourses /></Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Box sx={{ maxHeight: '400px', overflowY: 'auto' }} className='thick-border dashboard-page-section'><Classes /></Box>
                    </Grid>


                    <Grid item xs={12}>
                        <Box className="thick-border dashboard-page-section"><Assignments /></Box>
                    </Grid>    

                    <Grid item xs={12}>
                        <LearningProgression />
                    </Grid> 

                    <Grid item xs={12}>
                        <EarlyWarningsSlider />
                    </Grid> 

                    <Grid item xs={12}>
                        <BenchmarkMasterySlider />
                    </Grid> 

                    <Grid item xs={12}>
                        <Chat />
                    </Grid>  

                    <Grid item xs={12}>
                        <Meetings />
                    </Grid>    
                  </Grid>
              </div>

              
  











          <DialogPopup
              title={popupTitle}
              open={!!popup}
              onClose={() => setPopup(null)}
              popupWidth={'1400px'}
          >
             <>
              {popup === 'resources' && <PopupResources qry={topSearch} />}
              {popup === 'bookmarks' && <PopupBookmarks />}
             </>
          </DialogPopup>
        
        </>
  )
}
export default TeacherWorkspacePage
